import { observer } from 'mobx-react-lite';
import React, { useRef, useState } from 'react'
import { useStore } from '../../../../../../hooks/useStore';
import {WistiaVideoEmbed} from './'

const MapVideoMobile = observer(() => {
    const {uiStore: {isMobile}} = useStore();
    // if (!isMobile) return null
    // console.log("b");
    

    return (
        <div>
            <WistiaVideoEmbed id="l370ii4xar" mobile={true} play={false}/>

            <style jsx>{`

                div {
                    display: none;
                    position: relative;
                }


                @media (max-width: 769px), (pointer: coarse) {
                    div {
                        display: block;
                    }

                }

            `}</style>
        </div>
    )
})

export default MapVideoMobile